import type { Background, Color } from './ToggleSwitch.h'

import { styled } from '@linaria/react'

export const Slider = styled.span<{
  background: Background
  colorDefault: Color
}>`
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: ${({ background }) => `var(${background})`};
  border-radius: 20px;

  &:after {
    position: absolute;
    content: '';
    height: 18px;
    width: 18px;
    left: 2px;
    bottom: 2px;
    background-color: ${({ colorDefault }) => `var(${colorDefault})`};
    border-radius: 50%;
    -webkit-transition: 0.2s;
    transition: 0.2s;
  }
`

export const Label = styled.label<{
  backgroundChecked: Background
  backgroundDisabled: Background
  colorDisabled: Color
  backgroundCheckedDisabled: Background
}>`
  position: relative;
  display: inline-block;
  width: 40px;
  height: 22px;

  input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }

  input:checked ~ ${Slider} {
    background: ${({ backgroundChecked }) => `var(${backgroundChecked})`};

    &:after {
      -webkit-transform: translateX(18px);
      -ms-transform: translateX(18px);
      transform: translateX(18px);
    }
  }

  input:disabled ~ ${Slider} {
    background: ${({ backgroundDisabled }) => `var(${backgroundDisabled})`};
    cursor: not-allowed;

    &:after {
      background: ${({ colorDisabled }) => `var(${colorDisabled})`};
    }
  }

  input:checked:disabled ~ ${Slider} {
    background: ${({ backgroundCheckedDisabled }) =>
      `var(${backgroundCheckedDisabled})`};
    cursor: not-allowed;

    &:after {
      background: ${({ colorDisabled }) => `var(${colorDisabled})`};
    }
  }
`
